import React from 'react';
import { Button } from '@fiverr-private/button';
import { Link } from '@fiverr-private/typography';
import { useBriefContext } from '@fiverr-private/ai_brief/dist/esm/src/common/BriefContext';
import { useBriefCreationContext } from '../../context/BriefCreationContext';
import { AppI18n } from '../../i18n';
import { briefCreationClickAction } from '../../monitoring';
import { Step } from '../../constants';

export const MissingFieldsButton = () => {
  const { missingFieldsCount, focusFirstMissingSection, contextId, source, parentElement, variant } =
    useBriefCreationContext();
  const { editedSectionId, scrollToSection } = useBriefContext();

  if (!missingFieldsCount) {
    return null;
  }

  const handleClick = () => {
    if (editedSectionId) {
      scrollToSection(editedSectionId);
    } else {
      focusFirstMissingSection();
    }

    briefCreationClickAction({
      step: Step.Edit,
      action: 'missing_fields',
      briefContextId: contextId,
      eventSource: source || '',
      parentElement,
      variant,
    });
  };

  return (
    <Button onClick={handleClick} variant="ghost">
      <Link>
        <AppI18n
          k="missing_field"
          params={{
            count: missingFieldsCount,
          }}
        />
      </Link>
    </Button>
  );
};
